import i18next from "i18next";

export const getLanguage = () => i18next.language || window.localStorage.lng;
export const setLanguage = (lng) => i18next.changeLanguage(lng);
